<template>
    <div>
        <b-row>
            <b-col sm="12">
                <DateTime title="Vencimento" field="dueDate" formName="recordSearchFilterModalForm"
                    format="DD/MM/YYYY" type="date" :range="true" v-model="period" />
            </b-col>
            <b-col sm="6">
                <InputDecimal title="Valor Inicial" field="valueStart" formName="recordSearchFilterModalForm"
                    :markFormDirty="false" v-model="valueStart" />
            </b-col>
            <b-col sm="6">
                <InputDecimal title="Valor Final" field="valueEnd" formName="recordSearchFilterModalForm"
                    :markFormDirty="false" v-model="valueEnd" />
            </b-col>
        </b-row>
        <div class="record-search-filter-modal-actions text-right">
            <Button _key="btnClearRecordFilter" title="Limpar" size="small" type="edit" :clicked="onClear" />
            <Button _key="btnCancelRecordFilter" title="Cancelar" size="small" type="danger" :clicked="onCancel" />
            <Button _key="btnApplyRecordFilter" title="Aplicar" classIcon="fa-solid fa-filter" size="small"
                type="primary" :disabled="!canApply" :clicked="onApply" />
        </div>
    </div>
</template>
<script>

import Button from "@/ui/forms/Button";
import DateTime from "@/ui/forms/DateTime";
import InputDecimal from "@/ui/forms/InputDecimal";

import { mapMutations } from "vuex";

export default {
    name: "RecordSearchFilterModal",
    components: { Button, DateTime, InputDecimal },
    props: {
        filter: {
            type: Object,
            default: () => ({ period: [], valueStart: 0, valueEnd: 0 }),
        },
    },
    data() {
        return {
            period: [],
            valueStart: 0,
            valueEnd: 0,
        };
    },
    created() {
        this.period = [...(this.filter.period || [])];
        this.valueStart = this.filter.valueStart || 0;
        this.valueEnd = this.filter.valueEnd || 0;
    },
    computed: {
        canApply() {
            let localFilled = (this.period.length == 2 && this.period[0] && this.period[1]) || this.valueStart > 0 || this.valueEnd > 0;
            let originallyFilled = (this.filter.period && this.filter.period.length == 2 && this.filter.period[0] && this.filter.period[1])
                || this.filter.valueStart > 0 || this.filter.valueEnd > 0;
            return localFilled || originallyFilled;
        },
    },
    methods: {
        ...mapMutations("generic", ["removeLoading"]),
        onClear() {
            this.period = [];
            this.valueStart = 0;
            this.valueEnd = 0;
            this.$emit('clear', { period: [], valueStart: 0, valueEnd: 0 });
            this.removeLoading(["btnClearRecordFilter"]);
        },
        onCancel() {
            this.$emit('cancel');
        },
        onApply() {
            this.$emit('apply', { period: this.period, valueStart: this.valueStart, valueEnd: this.valueEnd });
        },
    },
};
</script>
<style scoped>
.record-search-filter-modal-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 12px;
}
</style>
